<template>
    <table class="ui celled compact selectable table" v-show="core_waybills.length > 0">
        <thead class="center aligned">
            <tr class="ui form">
                <th :colspan="_.filter(updater_columns, (o) => { return o.toggle }).length +3">
                    <h3 class="ui header">
                        <!-- 快速更新表格 -->
                        {{ $t('ui.toolbox.core_waybills.quick_update_table') }}
                    </h3>
                    <div class="inline fields">
                        <div class="inline field" v-for="column in updater_columns">
                            <input type="checkbox" v-model="column.toggle" tabindex="0" class="hidden" :id="'quick_' + column.header_text">
                            <label :for="'quick_' + column.header_text">{{ column.header_text }}</label>
                        </div>
                    </div>
                </th>
            </tr>
            <tr>
                <th>
                    <!-- 類型 -->
                    {{ $t('models.materials') }}
                </th>
                <th>
                    <!-- 運單號碼 -->
                    {{ $t("models.attributes.core_waybills.number") }}
                </th>
                <th v-for="column in _.filter(updater_columns, (o) => { return o.toggle })">
                    {{ column.header_text }}
                </th>
                <th>
                    <button class="ui basic negative icon button" @click="remove_all_core_waybills" v-if="!is_loading">
                        <i class="remove icon"></i>
                    </button>
                </th>
            </tr>
        </thead>
        <tbody class="center aligned ui form">
            <tr class="warning">
                <td colspan="2">
                    <h3 class="ui header">
                        <!-- 批量修改 -->
                        {{ $t('ui.toolbox.core_waybills.batch_edit') }}
                    </h3>
                </td>
                <td v-for="column in _.filter(updater_columns, (o) => { return o.toggle })">
                    <span v-if="is_loading">{{ batch_update_core_waybill[column.attribute_name] }}</span>
                    <input v-else :type="column.type" v-model="batch_update_core_waybill[column.attribute_name]">
                </td>
                <td></td>
            </tr>
            <tr v-for="cw in core_waybills">
                <td>{{ cw.material.name }}</td>
                <td>{{ cw.number }}</td>
                <td v-for="column in _.filter(updater_columns, (o) => { return o.toggle })">
                    <span v-if="is_loading">{{ cw[column.attribute_name] }}</span>
                    <input v-else :type="column.type" v-model="cw[column.attribute_name]">
                </td>
                <td>
                    <button class="ui basic negative icon button" @click="remove_core_waybill(cw.identity)" v-if="!is_loading">
                        <i class="remove icon"></i>
                    </button>
                </td>
            </tr>
        </tbody>
        <tfoot class="center aligned">
            <tr v-if="is_loading">
                <th :colspan="_.filter(updater_columns, (o) => { return o.toggle }).length +3">
                    <div class="ui active centered inline loader"></div>
                </th>
            </tr>
            <tr v-else>
                <th :colspan="_.filter(updater_columns, (o) => { return o.toggle }).length +3">
                    <button class="ui basic positive button" @click="update_all">
                        {{ $t('ui.general.update') }}
                    </button>
                    <button class="ui basic negative button" @click="remove_all_core_waybills">
                        {{ $t('ui.general.cancel') }}
                    </button>
                </th>
            </tr>
        </tfoot>
    </table>
</template>

<script>
export default {
    props: {
        core_waybills: Array,
        updater_columns: Array,
    },
    data() {
        return {
            is_loading: false,
            batch_update_core_waybill: {},
        }
    },
    mounted() {
    },
    computed: {
    },
    watch: {
        batch_update_core_waybill: {
            handler (current_batch_update_core_waybill, old_batch_update_core_waybill) {
                for(let core_waybill of this.core_waybills) {
                    for(let column of _.filter(this.updater_columns, (o) => { return o.toggle })) {
                        if (current_batch_update_core_waybill[column.attribute_name]) {
                            core_waybill[column.attribute_name] = current_batch_update_core_waybill[column.attribute_name]
                        }
                    }
                }
            },
            deep: true
        },
        core_waybills: {
            handler(val, oldVal) {
                if (val.length == 0) {
                    this.batch_update_core_waybill = {}
                }
            }
        }
    },
    methods: {
        async update_all() {
            var params_objects = {}
            await new Promise(resolve => {
                this.is_loading = true
                resolve()
            })
            for (let core_waybill of this.core_waybills) {
                await new Promise(resolve => {
                    var columns = _.filter(this.updater_columns, (o) => {return o.toggle})
                    params_objects[core_waybill.identity] = {}
                    _.map(columns, (column) => {
                        params_objects[core_waybill.identity][column.attribute_name] = core_waybill[column.attribute_name]
                    })
                    resolve()
                })
            }
            for (let core_waybill of this.core_waybills) {
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybill_update).parse(
                    {
                        "core_waybill_identity": core_waybill.identity,
                    },
                    ""
                )
                var token = localStorage.getItem("authentication_token")
                await axios.post(url, params_objects[core_waybill.identity], {headers: { Authorization: token }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.remove_core_waybill(core_waybill.identity)
                        return Promise.resolve()
                    } else {
                        return Promise.reject(response.data)
                    }
                })
                .catch(error => {
                    console.log(error.response)
                    // this.$noty.error(core_waybill.number + "更新失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.update__name', {
                            name: core_waybill.number,
                        })
                    )
                }).finally(() => {
                })
            }

            await new Promise(resolve => {
                this.is_loading = false
                this.$parent.fetch_core_waybills()
                resolve()
            })
        },
        remove_core_waybill(core_waybill_identity) {
            this.$parent.quick_update_core_waybills = _.filter(this.$parent.quick_update_core_waybills, (o) => {return o.identity != core_waybill_identity})
        },
        remove_all_core_waybills() {
            for (let cw of this.core_waybills) {
                this.remove_core_waybill(cw.identity)
            }
        },
    },
    components: {
    }
}
</script>

<style scoped>
</style>
